import { useQuery } from 'react-query';
import request from '../../../helpers/request';
import { facilityMetersKeys } from './queryKeys';

const getFacilityMeters = async (
  facilityId,
  officeId,
  searchString,
  typeId
) => {
  const content = officeId ? 'офиса' : 'объекта';

  return await request.get(
    `/RentPlace/rental_house/${facilityId}/office/meter`,
    { officeId, searchString, typeId },
    `При загрузке счетчиков ${content} произошла ошибка`,
    []
  );
};

const useFacilityMeters = (facilityId, officeId, searchString, typeId, options) =>
  useQuery(
    facilityMetersKeys({ facilityId, officeId, searchString, typeId }),
    () => getFacilityMeters(facilityId, officeId, searchString, typeId),
    {
      enabled: !!facilityId,
      ...options
    }
  );

export default useFacilityMeters;
